import { render } from "./Entities-SchoolJobsList.vue?vue&type=template&id=799bfd4a&lang=html"
import script from "./Entities-SchoolJobsList.vue?vue&type=script&lang=js"
export * from "./Entities-SchoolJobsList.vue?vue&type=script&lang=js"

import "./Entities-SchoolJobsList.vue?vue&type=style&index=0&id=799bfd4a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__